import axios from 'axios';
import { apiUrl, execUrl } from 'libs/commonVar';

import * as common from 'libs/commonFunc';

export const getTagAPI = params => common.requestRaw(apiUrl + 'Tag', params, 'get');
export const postTagAPI = params => common.requestRaw(apiUrl + 'Tag', params, 'post');
export const putTagAPI = params => common.requestRaw(apiUrl + 'Tag', params, 'put');
export const deleteTagAPI = params => common.requestRaw(apiUrl + 'Tag', params, 'delete');
export const deleteAllTagAPI = params => common.requestRaw(apiUrl + 'Tag/DeleteAll', params, 'delete');

// export function postTagAPI(paramDatas) {
//   return axios({
//     method: 'post',
//     url: apiUrl + 'Tag',
//     params: paramDatas
//   });
// }

// export function putTagAPI(paramDatas) {
//   return axios({
//     method: 'put',
//     url: apiUrl + 'Tag',
//     params: paramDatas
//   });
// }


// WEBPACK FOOTER //
// ./src/script/libs/tagLib.js